/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'documents': {
    width: 12,
    height: 9,
    viewBox: '0 0 12 9',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd"><path pid="0" d="M2.714 1H1.162a.41.41 0 0 0-.412.406l.327 6.535c0 .224.184.406.411.406h8.524a.409.409 0 0 0 .411-.406l.327-5.552a.409.409 0 0 0-.411-.406H3.75L2.714 1z" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M10.75 4.018h-10"/></g>'
  }
})
